module.exports = __webpack_public_path__ + "img/left-curving-right.f2b8abeb.png";